import React, { useEffect, useState } from 'react'
import { Box, Divider, Grid, IconButton, styled } from '@mui/material'
import DefaultPainel from '../../components/shared/Painel'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import TableHeader from '../../components/shared/tables/TableHeader'
import BasicModal from '../../components/shared/modals/BaseModal'
import FilterButton from '../../components/buttons/FilterButton'
import { Add, DeleteForever, Edit } from '@mui/icons-material'
import { Gestores } from '../../services/http'
import FormGestor from './components/FormGestor'
import ModalGestor from './components/ModalGestor'
import gerarPaginacao from '../../services/pagination'
import { confirmDelete } from '../livros/functions'
import BaseFilter from '../../components/BaseFilter'
import BasicDatagrid from '../../components/shared/tables/BasicDatagrid'
import SmallTextField from '../../components/textfield/SmallTextfield'
import PrivateRC from '../../components/PrivateRC'
import SearchEndAdornment from '../../components/adornment/SearchEndAdornment'
import SearchStartAdornment from '../../components/adornment/SearchStartAdornment'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'

const filters = [
  {
    service: {
      folder: 'bibliotecas',
      file: 'Bibliotecas',
      relationship: ''
    },
    listLabel: 'biblioteca',
    label: 'Biblioteca',
    itemValue: 'id',
    itemText: 'apelido',
    id: 'includes[biblioteca][id]'
  }
]

const LibrariansTable = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '76vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start',
    justifyContent: 'normal',
    '&:nth-of-type(4)': {
      textAlign: 'center!important'
    }
  }
}))

const OpenButton = ({ ...props }) => (
  <FilterButton
    color="white"
    Icon={Add}
    {...props}
    text="Novo Gestor"
    bg="#000000BF"
  />
)

const Gestor = () => {
  const [status, setStatus] = useState(false)
  const [rows, setRows] = useState([])
  const [queryLibrarian, setQueryLibrarian] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [lastPage, setLastPage] = useState(1)
  const [gestor, setGestor] = useState(null)
  const [tloading, setTloading] = useState(false)
  const [query, setQuery] = useState({})

  const deleteGestor = async id => {
    await Gestores(id).delete({
      notification: true,
      message: 'Sucesso ao deletar bibliotecário'
    })
    getGestores({}, currentPage)
  }

  const columns = [
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 1
    },
    {
      field: 'gestor',
      headerName: 'Gestor',
      flex: 4
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 4
    },
    {
      field: 'actions',
      headerName: 'Ações',
      flex: 2,
      renderCell: ({ row }) => {
        return (
          <>
            <IconButton
              sx={{ color: 'rgba(234, 144, 39, 1)' }}
              onClick={() => {
                setEditando(true)
                setGestor(row)
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={() => {
                const msg = `Deseja deletar o gestor ${row.gestor}`
                confirmDelete(row.id, 'gestor', msg, deleteGestor)
              }}
              color="error"
            >
              <DeleteForever />
            </IconButton>
          </>
        )
      }
    }
  ].map(item => ({ ...item, headerClassName: 'jaostyle', sortable: false }))

  const getGestores = async (filters, page) => {
    setTloading(true)
    const { data } = await Gestores().show({
      'includes[]': 'user,biblioteca',
      page,
      ...filters
    })
    setCurrentPage(data.current_page)
    setLastPage(data.last_page)
    const aux = data.data.map(item => ({
      ...item,
      gestor: item.user.name,
      email: item.user.email,
      biblioteca: item.biblioteca.apelido
    }))
    setRows(aux)
    setTloading(false)
  }

  const init = async () => {
    getGestores()
    setRows([])
  }

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => getGestores(query, value)
  )

  let typingTimer = ''

  const getLector = () => {
    setQuery(
      Object.assign(query, {
        'includes[user][name]': `%${queryLibrarian?.toUpperCase()}%`
      })
    )
    getGestores(query)
  }

  const handleClean = () => {
    if (queryLibrarian !== '') {
      setQueryLibrarian('')
      delete query['includes[user][name]']
      getGestores({ ...query, 'includes[user][name]': undefined })
    }
  }

  useEffect(() => {
    init()
  }, [])

  const [editando, setEditando] = useState(false)

  return (
    <Box>
      <ModalGestor
        open={editando}
        onClose={value => {
          setEditando(value)
          getGestores({}, currentPage)
        }}
        data={gestor}
        id_gestor={gestor?.id}
      />
      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer>
          <>
            <TableHeader
              titulo="Gestores"
              controls={
                <MobileFilterHeaderContainer>
                  <PrivateRC roles="gestor">
                    <SmallTextField
                      sx={{ marginRight: '15px' }}
                      type="text"
                      placeholder="Gestor"
                      color="white"
                      variant="standard"
                      onKeyDown={() => {
                        clearTimeout(typingTimer)
                      }}
                      onKeyUp={() => {
                        clearTimeout(typingTimer)
                        typingTimer = setTimeout(getLector, 1000)
                      }}
                      onChange={({ target }) => {
                        setQueryLibrarian(target.value)
                      }}
                      value={queryLibrarian}
                      InputProps={{
                        style: { color: 'white' },
                        startAdornment: <SearchStartAdornment />,
                        endAdornment: (
                          <SearchEndAdornment action={handleClean} />
                        )
                      }}
                    />
                  </PrivateRC>
                  <BasicModal
                    title="Novo Gestor"
                    Caller={OpenButton}
                    status={status}
                    closeEvent={event => {
                      setStatus(event)
                    }}
                    sx={{
                      minWidth: '32vw',
                      width: { xs: '100vw', md: '32vw' }
                    }}
                  >
                    <FormGestor
                      submitMethod="post"
                      onSubmitEnd={() => {
                        getGestores({}, currentPage)
                        setStatus(false)
                      }}
                    />
                  </BasicModal>
                  <BaseFilter
                    color="white"
                    filter={filters}
                    onChange={value => {
                      setQuery(Object.assign(query, value))
                      getGestores(query)
                    }}
                  />
                </MobileFilterHeaderContainer>
              }
            />

            <Grid item xs={12} sm={12}>
              <Divider />
              <LibrariansTable
                rows={rows}
                columns={columns}
                disableColumnMenu
                pagination={pagination}
                loading={tloading}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default Gestor
